import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import heroImage from '../assets/hero/interview.png?url'
import styles from './Hero.module.css'

export function Hero(): React.ReactElement {
  return (
    <section className={styles.hero}>
      <Container className={styles.hero__inner}>
        <div>
          <nav className={styles.hero__breadcrumb} aria-label="Fil d'Ariane">
            <a href="/about/ulule/">À propos</a>
            <span aria-hidden="true">›</span>
            <span className={styles.hero__breadcrumbTag}>Espace presse</span>
          </nav>
          <h1 className={styles.hero__title}>
            Chouette, on passe dans vos <span className={styles.hero__titleHighlight}>médias</span>.
          </h1>
          <div className={styles.hero__actions}>
            <plume.RoundButton as="a" href="#contact" color="black" size="big">
              Contact presse
            </plume.RoundButton>
            <plume.RoundButton as="a" href="#ressources" color="black" kind="secondary" size="big">
              Logo et illustrations
            </plume.RoundButton>
          </div>
        </div>
        <div className={styles.hero__art}>
          <img
            className={styles.hero__image}
            src={heroImage}
            alt="Journalistes interviewant un porteur de projet Ulule"
            width={1448}
            height={1086}
          />
        </div>
      </Container>
    </section>
  )
}
